import { cn } from '@/lib/utils';

function SkeletonList({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('border-grey-2 flex w-full flex-col items-start border-t-2', className)} {...props}>
      {[...Array(3)].map((_, i) => (
        <div key={i} className="border-grey-2 flex h-[94px] w-full flex-row items-center gap-4 border-b-2 bg-white p-5">
          <div className="bg-grey-2 h-9 w-9 rounded-[36px]"></div>
          <div className="flex h-[42px] w-[200px] flex-col items-start gap-2 p-0">
            <div className="bg-grey-2 h-[16px] w-[200px] rounded" />
            <div className="bg-grey-2 h-[16px] w-[100px] rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}

export { SkeletonList };
